module.exports = __webpack_public_path__ + "static/media/p1.0e80bf83.jpg";